module.exports = __webpack_public_path__ + "img/access-form.fc85378e.png";